//Importing the icons
import AvTimerOutlinedIcon from '@mui/icons-material/AvTimerOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import MobileScreenShareOutlinedIcon from '@mui/icons-material/MobileScreenShareOutlined';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';


const Card = [
    {
      id: 1,
      icon:  AvTimerOutlinedIcon,
      title: "Skip the Wait",
      descption:"Unmatched customer support in less than 30 seconds", 
    },
    {
      id: 2,
      icon: SupportAgentOutlinedIcon,
      title: "Talk to a Real Person",
      descption:"98% of customer calls are answered by a live technician",
    },
    {
      id: 3,
      icon:  MobileScreenShareOutlinedIcon,
      title: "Get Online Support",
      descption:"Convenient support options when you need assistance",
    },
    {
      id: 4,
      icon:  ForumOutlinedIcon,
      title: "Be Happy",
      descption:"98% of customers rate our service good to excellent",
    }
    
    ]
    
    export default Card
